import React, { createContext, useEffect, useState } from 'react'

export const Context = createContext(false)

export default function MenuContext({ children }) {
  const [isOpen, setIsOpen] = useState(false)

  const setIsClosed = () => setIsOpen(false)
  const toggleIsOpen = () => setIsOpen(prevIsOpen => !prevIsOpen)

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }, [isOpen])

  return (
    <Context.Provider 
      value={{
        isOpen,
        setIsClosed,
        toggleIsOpen,
      }}
    >
      {children}
    </Context.Provider>
  )
}